module.exports = __webpack_public_path__ + "static/media/11NEPAD11.818d0f5b.jpg";